/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SkillEfficacyMetrics,
  SkillEfficacyMetrics$inboundSchema,
} from "./skillefficacymetrics.js";

export type SkillInsightMetrics = {
  activatedSessions: number;
  activations: number;
  averageSessionCostUsd?: number | undefined;
  efficacy?: SkillEfficacyMetrics | undefined;
  sessionCostUsd: number;
};

/** @internal */
export const SkillInsightMetrics$inboundSchema: z.ZodMiniType<
  SkillInsightMetrics,
  unknown
> = z.pipe(
  z.object({
    activated_sessions: z.int(),
    activations: z.int(),
    average_session_cost_usd: z.optional(z.number()),
    efficacy: z.optional(SkillEfficacyMetrics$inboundSchema),
    session_cost_usd: z.number(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "activated_sessions": "activatedSessions",
      "average_session_cost_usd": "averageSessionCostUsd",
      "session_cost_usd": "sessionCostUsd",
    });
  }),
);

export function skillInsightMetricsFromJSON(
  jsonString: string,
): SafeParseResult<SkillInsightMetrics, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillInsightMetrics$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillInsightMetrics' from JSON`,
  );
}
